import React from 'react';
import style from './QuickInformation.module.css';
import { QuickInformation } from '../../pages/runtime-typechecker';

type QuickInformationProps = {
  quickInformation: QuickInformation;
};

const QuickInformationSection = ({
  quickInformation
}: QuickInformationProps) => {
  const heading = `Quick Information for ${quickInformation.source} to ${quickInformation.destination} Bus Services`;
  const travelTime = `${Math.floor(
    quickInformation.duration / 60
  )}h ${quickInformation.duration % 60}min`;
  const distance = `${quickInformation.distance}Km`;
  const busOperatorNames = quickInformation.busNames.join(', ');
  const minPrice = `Rs. ${quickInformation.minPrice}`;

  return (
    <div className="visibilityAuto" style={{ paddingBottom: '20px' }}>
      <div className="desktopShow">
        {' '}
        <h2 className={style.quickInformationHeading}>{heading}</h2>
      </div>
      <div className={style.quickInformationWrap}>
        <h2 className="mobileShow paddingLR16" style={{ display: 'none' }}>
          <span
            className="font22 latoLight appendBottom10"
            style={{ display: 'block' }}
          >
            {'Quick Information'}
          </span>
        </h2>
        <table className={style.genericInformationText}>
          <tbody>
            {quickInformation.distance && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Distance'}
                </td>
                <td>:</td>
                <td>{distance}</td>
              </tr>
            )}

            {quickInformation.duration && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Avg. Travelling Time'}
                </td>
                <td>:</td>
                <td>{travelTime}</td>
              </tr>
            )}

            {quickInformation.source && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Bus Departs From'}
                </td>
                <td>:</td>
                <td>{quickInformation.source}</td>
              </tr>
            )}

            {quickInformation.destination && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Bus Arrives In'}
                </td>
                <td>:</td>
                <td>{quickInformation.destination}</td>
              </tr>
            )}

            {quickInformation.earliestBus && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Earliest Bus'}
                </td>
                <td>:</td>
                <td>{quickInformation.earliestBus}</td>
              </tr>
            )}

            {quickInformation.lastBus && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Last Bus'}
                </td>
                <td>:</td>
                <td>{quickInformation.lastBus}</td>
              </tr>
            )}

            {quickInformation.minPrice && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Cheapest Bus Ticket'}
                </td>
                <td>:</td>
                <td>{minPrice}</td>
              </tr>
            )}
            {quickInformation.busNames && quickInformation.busNames.length > 0 && (
              <tr>
                <td className={`appendBottom3 ${style.genericInformationKey}`}>
                  {'Bus Operators'}
                </td>
                <td>:</td>
                <td>{busOperatorNames}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuickInformationSection;
